import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "el-upload__tip" }
const _hoisted_2 = { class: "dialog-footer" }

import { computed, ref, PropType, Ref, watch, nextTick } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { auditInvoiceApplyItem, getInvoiceApplyInfo } from '@/api/operation'
import { ElInput, ElMessage } from 'element-plus'
import { InvoiceTitleType } from '@/types/types'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import type { UploadProps, UploadUserFile } from 'element-plus'
import { Operation, Plus } from '@element-plus/icons-vue'
import AdvancedSettingContainer from '@/components/AdvancedSettingContainer.vue'

export type ShowDialogType = 'create' | 'edit'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'AuditApplyItem',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  itemInfo: {
    type: Object as PropType<Record<string, any>>,
    required: true,
    default: () => {},
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { commonStates, getCommonStateDesc, invoiceTitleTypes, getInvoiceTitleTypeDesc } =
  useProtocolEnums()
const { t } = useI18n()





const covers = ref<UploadUserFile[]>([
  // {
  //   name: '',
  //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
  // },
  // {
  //   name: '',
  //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
  // },
])

const dialogImageUrl = ref('')
const dialogVisible = ref(false)

const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
  console.log(uploadFile, uploadFiles)
}

const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!
  dialogVisible.value = true
}

const handleSuccess: UploadProps['onSuccess'] = (res, uploadFile, uploadFiles) => {
  uploadFile.url = res.files[0]
}

const createRawFormData = () => ({})

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())

const formRules = ref({})

const item = ref<Record<string, any>>({})
const apply = ref<Record<string, any>>({
  title: {
    type: '',
    name: '',
    taxId: '',
    address: '',
    phone: '',
    bankName: '',
    bankAccount: '',
  },
})

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

watch(showDialog, async (val) => {
  if (val) {
    formData.value = createRawFormData()

    item.value = props.itemInfo
    formData.value.id = item.value.id
    formData.value.state = item.value.state
    formData.value.remark = item.value.remark
    covers.value = []
    if (item.value.invoiceUrl != '') {
      covers.value.push({ url: item.value.invoiceUrl, name: '' })
    }

    getInvoiceApplyInfo({ id: item.value.applyId }).then((res) => {
      apply.value = res.record
    })
  }
})

const submit = async () => {
  console.log('submit')
  try {
    await formCom.value.validate()
    formData.value.url = ''
    covers.value.forEach((item) => {
      console.log('------>url: ', item.url)
      formData.value.url = item.url
    })

    await auditInvoiceApplyItem(formData.value)
    ElMessage.success(t(`Base.opSuccess`))

    emit('submitted')
    showDialog.value = false
  } catch (error) {
    console.log(error)
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _unref(t)('Operation.auditInvoice'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "invoice-drawer"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: formRules.value
      }, {
        default: _withCtx(() => [
          _createVNode(AdvancedSettingContainer, {
            title: _ctx.$t('Operation.invoiceInfo')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions, { column: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('Operation.invoiceType')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getInvoiceTitleTypeDesc)(apply.value.title.type)), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('Operation.invoiceName')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(apply.value.title.name), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          (apply.value.title.type == _unref(InvoiceTitleType).ITT_COMPANY)
                            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                key: 0,
                                label: _unref(t)('Operation.invoiceTaxId')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(apply.value.title.taxId), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (apply.value.title.type == _unref(InvoiceTitleType).ITT_COMPANY)
                            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                key: 1,
                                label: _unref(t)('Operation.invoiceAddress')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(apply.value.title.address), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (apply.value.title.type == _unref(InvoiceTitleType).ITT_COMPANY)
                            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                key: 2,
                                label: _unref(t)('Operation.invoicePhone')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(apply.value.title.phone), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (apply.value.title.type == _unref(InvoiceTitleType).ITT_COMPANY)
                            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                key: 3,
                                label: _unref(t)('Operation.invoiceBankName')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(apply.value.title.bankName), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (apply.value.title.type == _unref(InvoiceTitleType).ITT_COMPANY)
                            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                key: 4,
                                label: _unref(t)('Operation.invoiceBankAccount')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(apply.value.title.bankAccount), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('Operation.invoiceEmail')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(apply.value.title.email), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.id'),
                    prop: "id"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.id) = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: item.value.operatorName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.operatorName) = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.orderAmount')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: item.value.totalAmount,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.totalAmount) = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.invoiceAmount')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: item.value.invoiceAmount,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.invoiceAmount) = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.orderId')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: item.value.orderIds,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.orderIds) = $event)),
                        type: "textarea",
                        disabled: true,
                        rows: 1
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.operation')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.state,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.state) = $event)),
                        placeholder: _ctx.$t('Evses.state'),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonStates), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.remark')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.remark,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.remark) = $event)),
                        type: "textarea",
                        rows: 1
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.invoiceFile'),
                    prop: "covers"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { style: {"width":"100%","min-height":"100px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_upload, {
                            "file-list": covers.value,
                            "onUpdate:file-list": _cache[7] || (_cache[7] = ($event: any) => ((covers).value = $event)),
                            accept: "image/png,image/jpg,image/jpeg,.pdf",
                            class: "upload-demo",
                            action: "/cms/media/upload",
                            multiple: "",
                            "on-preview": handlePictureCardPreview,
                            "on-remove": handleRemove,
                            limit: 3,
                            "on-success": handleSuccess
                          }, {
                            tip: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('Base.maxBatchInvoiceSize')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, { type: "primary" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('Base.uploadFile')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["file-list"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})